import React from 'react'
// context
import { ActionContext } from 'context/index'
// graphql
import { PLAN_ACTION_RESOURCES_LIST_QUERY } from 'graphql/planActions/queries'
// types
import { LogEntityTypes } from 'types/graphql'
// view components
import ResourcesListContainer from 'containers/Activities/components/ResourcesList'

const ActionResourcesList: React.FC = () => {
  const { entity } = React.useContext(ActionContext) as any

  const { actionCreateResource, actionDeleteResource, actionModifyResource } = entity.currentPermissions

  return (
    <ResourcesListContainer
      canCreate={actionCreateResource}
      canDelete={actionDeleteResource}
      canModify={actionModifyResource}
      entity={{ ...entity, entityType: LogEntityTypes.Action }}
      query={PLAN_ACTION_RESOURCES_LIST_QUERY}
      variables={{
        filter: {
          planActionId: entity.id
        }
      }}
    />
  )
}

export default ActionResourcesList
